module.exports = function() {
  return new Worker(__webpack_public_path__ + "web-worker.5ee4715c6ce6ad5e35dc.js");
};